import {DesignServiceModel} from "../../../../models/domain/designServiceModel";
import {FaCheck} from "react-icons/fa";
import * as React from "react";

/**
 * The DesignServicesSelectedOffer component is used to display the selected cart item design services.
 * @param price The cart item price of the design services.
 * @constructor
 */
export const DesignServicesSelectedOffer = ({model: {formatted: {price}}}: { model: DesignServiceModel }) => {
    return (
        <div className="d-flex align-items-center border-top pt-2">
            <FaCheck size={18} className="text-success me-1"/>
            <div className="d-block fw-bold">Added Design Services <span
                className="fw-normal">({price} per hour)</span>
            </div>
        </div>
    )
}